import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css'; // 글로벌 CSS 로드
import App from './App';
// Import service worker registration
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
// 서비스 워커를 등록하여 PWA 기능을 활성화합니다.
serviceWorkerRegistration.register();


